<template>
    <Modal v-model="dialogShow" width="420" class-name="vertical-center-modal no-padding">
        <div class="close-btn" slot="close">
            <i class="iconfont icon-pop-close"></i>
        </div>
        <div class="contact-cont">
            <div class="imgCon">
                <img src="../../../../images/sucessDialog.png" alt="">
            </div>
            <p class="Text">兑换成功，感谢您的支持！</p>
            <span class="smallText" v-if="msg">您的兑换信息已经收到,<br/>我们将在3个工作日内安排发货，感谢您的支持！</span>
        </div>
    </Modal>
</template>
<script>
    export default{
        data(){
            return {
                timer:3,
                dialogShow:false,
                msg: false
            }
        },
        methods:{
            open(color){
                if(color){
                    this.msg = true
                }
                this.dialogShow = true;
                let interval = setInterval(()=>{
                    this.timer--;
                    if(this.timer<1){
                        clearInterval(interval);
                        this.$router.go(0);
                        this.dialogShow = false;
                    }
                },1000);
            },
            cancel(){
                this.$router.go(0)
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .contact-cont{
        height: 360px;
        >.imgCon{
            display: inline-block;
            text-align: center;
            >img{
                margin-top: 61px;
            }
        }
        i{
            font-size:44px;
            color:#308697;
        }
        .Text{
            font-size: 20px;
            color: #353838;
            letter-spacing: 0;
            text-align:center;
            margin-top: 18px;
            >span{
                font-size: 20px;
                color:#E14B5D;
            }
        }
        .time{
            font-size: 14px;
            color: #308697;
            letter-spacing: 0;
            text-align:center;
            margin-top:9px;
        }
        .button{
            margin-top: 64px;
            width: 100%;
            height: 40px;
            text-align: center;
            >span{
                display: inline-block;
                width: 200px;
                height: 100%;
                border-radius: 4px;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                cursor: pointer;
                &:hover{
                    opacity: 0.8;
                }
                &:last-child{
                    background: #308697;
                    color: #FFFFFF;
                }
            }
        }
        .smallText{
            margin-top: 20px;
            font-size: 12px;
            color:#6C6F70;
        }
    }
</style>
<style scoped>
    .contact-cont p.text{
        font-size: 12px;
        color:#308697;
        text-align:center;
    }
</style>
